<template>
  <v-container>
    <ValidationObserver ref="form">
      <FormToolbar
        :title="edit ? 'Edit Tank' : 'New Tank'"
        :onSubmitClick="submitForm"
        :onCloseClick="onCloseClick"
        :disableSubmitValue="false"
      />
      <v-form class="mt-1" @keyup.enter.native="submitForm">
        <v-container>
          <v-row>
            <v-col cols="12" sm="8">
              <ValidationProvider
                name="Vessel"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  ref="firstInput"
                  v-model="entity.vesselId"
                  :items="getVessels"
                  item-text="name"
                  item-value="id"
                  :error-messages="errors"
                  label="Vessel"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="4">
              <ValidationProvider
                name="Tank Name"
                rules="required|max:50"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="text"
                  v-model="entity.tankName"
                  :error-messages="errors"
                  label="Tank Name"
                  :counter="50"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" lg="4">
              <ValidationProvider
                name="Tank Type"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  v-model="entity.tankBulkType"
                  :items="getBulkTypes"
                  item-text="value"
                  item-value="value"
                  :error-messages="errors"
                  label="Tank Type"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" lg="4">
              <ValidationProvider
                name="Bulk"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  v-model="entity.bulkName"
                  :items="getBulksByType(entity.tankBulkType)"
                  item-text="bulkName"
                  item-value="bulkName"
                  :error-messages="errors"
                  label="Bulk"
                  :disabled="!entity.tankBulkType"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4">
              <ValidationProvider
                name="UOM"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  v-model="entity.qtyUom"
                  :items="getTankUnitOfMeasurements"
                  :error-messages="errors"
                  label="Qty Unit of Measurement"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="4">
              <ValidationProvider
                name="Maximum Capacity"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="entity.maxCapacity"
                  type="number"
                  :error-messages="errors"
                  :label="
                    !entity.qtyUom
                      ? 'Max Capacity'
                      : `Max Capacity (${entity.qtyUom})`
                  "
                  :disabled="!entity.qtyUom"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-col cols="12">
            <v-checkbox
              disabled
              v-if="edit"
              v-model="entity.isActive"
              label="Active"
            ></v-checkbox>
          </v-col>
        </v-container>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import FormToolbar from '../ui/FormToolbar.vue';
import '../../validators';

export default {
  props: {
    edit: Boolean,
    entity: Object,
    onSubmitClick: Function,
    onCloseClick: Function,
    bus: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    FormToolbar,
  },
  created() {
    this.$store.dispatch('bulksStore/loadBulkTypes');
  },
  mounted() {
    this.bus.$on('resetForm', this.resetForm);
  },
  computed: {
    ...mapGetters({
      getVessels: 'vesselsStore/getVessels',
      getBulkTypes: 'bulksStore/getBulkTypes',
      getBulks: 'bulksStore/getBulks',
      getBulksByType: 'bulksStore/getBulksByType',
      getTankUnitOfMeasurements: 'tanksStore/getTankUnitOfMeasurements',
    }),
  },
  methods: {
    submitForm() {
      this.$refs.form.validate()
        .then((isValid) => {
          if (isValid) this.onSubmitClick();
        });
    },
    resetForm() {
      this.$nextTick(() => this.$refs.firstInput.focus());
      this.$refs.form.reset();
    },
  },
};
</script>
